// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"one-of-choice_radioGroup__NGK14","customOptionInput":"one-of-choice_customOptionInput__2Y2jm"};